import React from 'react';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null, errorInfo: null };
    }

    static getDerivedStateFromError(error) {
        // Aktualisiere den State, sodass beim nächsten Rendering die Ersatz-UI angezeigt wird.
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        // Sie können den Fehler auch an einen Fehler-Reporting-Dienst senden
        console.error("Uncaught error:", error, errorInfo);
        this.setState({
            error: error,
            errorInfo: errorInfo
        });
    }

    render() {
        if (this.state.hasError) {
            // Sie können jede beliebige Ersatz-UI rendern
            return (
                <div className="min-h-screen flex items-center justify-center bg-slate-50 dark:bg-slate-900 p-4 font-sans">
                    <div className="max-w-md w-full bg-white dark:bg-slate-800 rounded-2xl shadow-xl p-8 border border-slate-200 dark:border-slate-700 text-center">
                        <div className="bg-red-100 dark:bg-red-900/30 w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6">
                            <i className="fas fa-exclamation-triangle text-red-600 dark:text-red-500 text-3xl"></i>
                        </div>
                        <h1 className="text-2xl font-bold text-slate-900 dark:text-white mb-4">
                            Hoppla! Etwas ist schiefgelaufen.
                        </h1>
                        <p className="text-slate-600 dark:text-slate-400 mb-8">
                            Die Anwendung hat einen unerwarteten Fehler festgestellt. Bitte versuchen Sie, die Seite neu zu laden.
                        </p>
                        <div className="flex flex-col gap-3">
                            <button
                                onClick={() => window.location.reload()}
                                className="w-full bg-primary hover:bg-primary-dark text-white font-semibold py-3 px-6 rounded-xl transition-colors shadow-lg shadow-primary/20"
                            >
                                Seite neu laden
                            </button>
                            <button
                                onClick={() => window.location.href = '/'}
                                className="w-full bg-slate-100 hover:bg-slate-200 dark:bg-slate-700 dark:hover:bg-slate-600 text-slate-700 dark:text-slate-200 font-semibold py-3 px-6 rounded-xl transition-colors"
                            >
                                Zur Startseite
                            </button>
                        </div>
                        {process.env.NODE_ENV === 'development' && this.state.error && (
                            <div className="mt-8 text-left">
                                <details className="cursor-pointer group">
                                    <summary className="text-xs font-semibold text-slate-400 uppercase tracking-widest group-hover:text-slate-600 transition-colors">
                                        Fehlerdetails anzeigen
                                    </summary>
                                    <pre className="mt-4 p-4 bg-slate-100 dark:bg-slate-950 rounded-lg text-[10px] text-red-600 dark:text-red-400 overflow-auto max-h-48 whitespace-pre-wrap font-mono">
                                        {this.state.error.toString()}
                                        <br />
                                        {this.state.errorInfo.componentStack}
                                    </pre>
                                </details>
                            </div>
                        )}
                    </div>
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
